import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let SignatureOption: LazyOption = createLazyOption(
    {
        key: 'signature',
        titleStringKey: 'optionTitle_signature',
        searchTermsStringKey: 'optionTitle_signature',
        allowedOptionKeys: ['MailSignatures'],
    },
    lazyFullModule,
    m => m.default
);
export default SignatureOption;
